import { useRemoteClientPost, useRemoteClientPut } from '@/configs/http-client'
import { Endpoints } from '@/remote/endpoints'
import { useLocalStorage } from '@/remote/local-storage'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { Button } from '../components/ui/button'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../components/ui/form'
import { Input } from '../components/ui/input'
import { useToast } from '../hooks'
import { CostCenterFormSchema, costCenterSchema } from '../validators/cost-center-validator'

interface CostCenterFormProps {
  data?: CostCenterFormSchema
  closeDialog?: () => void
  updateList?: () => void
}

export default function CostCenterForm({ data, closeDialog, updateList }: CostCenterFormProps) {
  const { httpClientPost } = useRemoteClientPost()
  const { httpClientPut } = useRemoteClientPut()
  // const { remoteClientGet } = useRemoteClientGet()
  const { getUnitId } = useLocalStorage()
  const [params] = useSearchParams()
  const { showToast } = useToast()
  // const [dataUnits, setDataUnits] = useState<any>([])
  const isEditMode = Boolean(data?.id)

  const form = useForm<CostCenterFormSchema>({
    resolver: zodResolver(costCenterSchema),
    defaultValues: {
      id: data?.id || 0,
      codigo: data?.codigo || '',
      descricao: data?.descricao || '',
      unidade: {
        id: data?.unidade?.id || params.get('unit') || getUnitId() || 0
      }
    }
  })

  // const fetchUnits = async () => {
  //   try {
  //     const response = await remoteClientGet(Endpoints.units, formatParams({
  //       page: 0,
  //       size: 1000,
  //       sortParam: 'id',
  //       order: 'desc',
  //       idUnidade: getUnitId()
  //     }));
  //     const data = response?.data?.data?.content;
  //     console.log(data)
  //     setDataUnits(data.map((unit: any) => ({
  //       ...unit,
  //       label: unit?.nomeFantasia,
  //       value: unit?.id
  //     })));
  //     console.log(dataUnits)
  //   } catch (error) {
  //     console.error(error);
  //     throw error
  //   }
  // }

  // useEffect(() => {
  //   console.log('fetching units')
  //   fetchUnits();
  // }, []);

  const onSubmit = async (formData: CostCenterFormSchema) => {
    const formattedData = {
      ...formData
    }

    try {
      if (isEditMode) {
        await httpClientPut(Endpoints.costCenter, { ...formattedData, inclusao: data?.inclusao })
        closeDialog?.()
        updateList?.()
      } else {
        delete formattedData?.id
        await httpClientPost(Endpoints.costCenter, { ...formattedData })
      }
      showToast('Requisição enviada com sucesso!', 'success')
      form.reset()
    } catch (error: any) {
      console.error('Erro no envio:', error?.response?.data?.errors)
      const errors = error?.response?.data?.errors
      if (errors) {
        for (const key in errors) {
          showToast(errors[key], 'error')
        }
      }
      showToast('Erro ao enviar requisição', 'error')
    }
  }

  return (
    <Form {...form}>
      <form id="formCostCenter" onSubmit={form.handleSubmit(onSubmit)} className="w-full flex flex-col m-auto h-auto">
        <FormField
          control={form.control}
          name="codigo"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                <span className="text-gray-400">*</span>
                Código
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="Código" />
              </FormControl>
              <FormMessage className="text-xs">{form.formState.errors.codigo?.message}</FormMessage>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="descricao"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                <span className="text-gray-400">*</span>
                Descrição
              </FormLabel>
              <FormControl>
                <Input {...field} placeholder="Descrição" />
              </FormControl>
              <FormMessage className="text-xs">{form.formState.errors.descricao?.message}</FormMessage>
            </FormItem>
          )}
        />
        {/* <FormField
          control={form.control}
          name="unidade.id"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                <span className="text-gray-400">*</span>
                Unidade</FormLabel>
              <FormControl>
                <ComboSelectWithLabel
                  defaultValue={field.value}
                  data={dataUnits}
                  onChange={(e) => {
                    //console.log(e)
                    const id = e?.value;
                    form.setValue('unidade.id', id);
                    form.trigger(['unidade.id']);
                  }}
                />
              </FormControl>
              <FormMessage className="text-xs">{form.formState.errors?.unidade?.message}</FormMessage>
            </FormItem>
          )}
        /> */}
        {!isEditMode && (
          <Button type="submit" className="bg-acelerafit-green-400 text-muted  font-bold hover:bg-acelerafit-green-300 mt-3 ">
            Enviar
          </Button>
        )}
      </form>
    </Form>
  )
}
